import { PositionManagerLeverageWrapper__factory } from "./typechain/PositionManagerLeverageWrapper__factory";
import BaseService from "../commons/BaseService";
export class PositionManagerLeverageWrapper extends BaseService {
    constructor(provider, positionManagerLeverageWrapperAddress, flashloanProviderAddress, assetConverterAddress) {
        super(provider, PositionManagerLeverageWrapper__factory);
        this.positionManagerLeverageWrapperAddress = positionManagerLeverageWrapperAddress !== null && positionManagerLeverageWrapperAddress !== void 0 ? positionManagerLeverageWrapperAddress : '';
        this.flashloanProviderAddress = flashloanProviderAddress !== null && flashloanProviderAddress !== void 0 ? flashloanProviderAddress : '';
        this.assetConverterAddress = assetConverterAddress !== null && assetConverterAddress !== void 0 ? assetConverterAddress : '';
    }
    mintAndLeverageTxData({ user, mintParams, maxSwapSlippage, tokenToBorrow, amountToBorrow }) {
        const initParams = { amountToBorrow: amountToBorrow, tokenId: "0", maxSwapSlippage: maxSwapSlippage, tokenToBorrow: tokenToBorrow, owner: user, flashLoanProvider: this.flashloanProviderAddress, assetConverter: this.assetConverterAddress };
        const tx = {};
        tx.data = PositionManagerLeverageWrapper__factory.createInterface().encodeFunctionData('mint', [mintParams, initParams]);
        tx.to = this.positionManagerLeverageWrapperAddress;
        tx.from = user;
        return tx;
    }
}
//# sourceMappingURL=index.js.map